<template>
  <div class="list">
    <div
        class="list-item"
        v-for="(block, index) in blocks"
        :key="index"
        @click="sendEvent(block)"
    >
      <router-link class="list-link" :to="block.link">
        <div class="list-block">
          <img
            class="image"
            :src="block.src"
            :style="{ width: getIconSize(block), height: getIconSize(block) }"
            alt=""
          >
          <div class="list-block-text">
            {{ block.text }}
          </div>
        </div>
      </router-link>

    </div>
    <startedDayPopup

    />
  </div>
</template>
<script setup>
import { reactive} from "vue";
import startedDayPopup from './popups/StartedDayPopup.vue'
import { trackGoal } from '@/helpers/metrika'

const defaultIconSize = 'clamp(44px, 14vw, 70px)'
const getIconSize = (block) => block.iconSize ?? defaultIconSize

const sendEvent = (block) => trackGoal('calculator_open', { calculator: block.link.slice(1) })


const blocks = reactive([
  {
    src: require("../images/icons/L.svg"),
    text: "Расчет лигатуры",
    link: '/ligature',
    // iconSize: '56px',
  },
  {
    src: require("../images/icons/longRing.svg"),
    text: "Расчет веса / длины шинки",
    link: '/longRing',
    // iconSize: 'clamp(44px, 14vw, 70px)',
  },
  {
    src: require("../images/icons/chain.svg"),
    text: "Расчет цепочек",
    link: '/chains'
  },
  {
    src: require("../images/icons/solder.svg"),
    text: "Расчет припоя",
    link: '/soldiers'
  },
  {
    src: require("../images/icons/halfSphere.svg"),
    text: "Расчет полусферы",
    link: '/halfSphere'
  },
  {
    src: require("../images/icons/cylinder.svg"),
    text: "Расчет трубки",
    link: '/cylinder'
  },
  {
    src: require("../images/icons/volumeWeight.png"),
    text: "Расчет веса по объёму",
    link: '/volumeWeight',
    iconSize: 'clamp(55px, 14vw, 70px)',
  },
  {
    src: require("../images/icons/wax.svg"),
    text: "Расчет восковки",
    link: '/waxWeight',
    iconSize: 'clamp(60px, 14vw, 70px)',
  },
  {
    src: require("../images/icons/mix.svg"),
    text: "Смешивание проб",
    link: '/assayMix',
    iconSize: 'clamp(70px, 14vw, 70px)',
  },
])
</script>

<style lang="scss" scoped>
.list{
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-items: center;
  align-items: start;
  width: 92vw;
  height: calc(100vh - 140px);;
  overflow-y: auto;
  gap: 0px 12px;
  padding-bottom: 20px;
  &-item{
    width: 100%;
    padding-bottom: 26px; // место под текст, т.к. он позиционируется ниже блока
  }
  &-link {
    display: block;
    width: 100%;
    text-decoration: none;
  }
  &-block {
    display: flex;
    border-radius: 25px;
    width: 100%;
    aspect-ratio: 1 / 1;
    background: rgb(0 0 0 / 20%);
    text-align: center;
    align-items: center;
    justify-content: center;
    position: relative;
    &-text {
      position: absolute;
      bottom: -26px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      color: #fff;
      width: 100%;
      height: 20px;
    }
  }
}
.image {
  filter: invert(100%) sepia(26%) saturate(1374%) hue-rotate(189deg) brightness(96%) contrast(91%);
}

</style>
